var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _path, _path2, _g32, _g33, _g34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoulMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_layer_1",
    "data-name": "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "101 63 680 680",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .year-arcane, .static-years, .cls-6, .cls-7, .cls-8, .age_group-item {\n        font-family: HelveticaNeue, 'Helvetica Neue';\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-10, .cls-11 {\n        fill: #DACAB7;\n      }\n\n      g.dimmed {\n        text {fill: #FFF4E6; stroke: none};\n        circle {stroke: #5F5C54; fill: #5F5C54};\n        rect {stroke: #5F5C54, fill: #5F5C54};\n        line {stroke: #5F5C54};\n        .cls-15 {stroke: #5F5C54};\n        .cls-31, .cls-29 {fill: #5F5C54};\n      }\n\n      .cls-1, .cls-7 {\n        font-size: 24.5px;\n      }\n\n      .cls-2, .cls-6 {\n        font-size: 14px;\n      }\n\n      .cls-12 {\n        font-family: Helvetica, Helvetica;\n      }\n\n      .year-arcane, .static-years, .age_group-item, .cls-13 {\n        fill: #E7D6AF;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-6, .cls-7, .cls-8, .cls-12 {\n        fill: #161515;\n      }\n\n      .cls-13 {\n        fill: #DACAB7;\n      }\n\n      .cls-12, .age_group-item {\n        font-size: 7px;\n      }\n\n      .cls-14 {\n        fill: #ffbf5d;\n        stroke: #ffbf5d;\n      }\n\n      .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-10, .cls-20, .cls-21, .cls-11, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-10, .cls-20, .cls-21, .cls-11, .cls-22, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28 {\n        stroke-width: 2.62987px;\n      }\n\n      .cls-15, .cls-16, .cls-19, .cls-20, .cls-21, .cls-23, .cls-27 {\n        fill: none;\n      }\n\n      .cls-15, .cls-10 {\n        stroke: #DACAB7;\n      }\n\n      .cls-16, .cls-28 {\n        stroke: #DACAB7;\n      }\n\n      .cls-3, .cls-8 {\n        font-size: 42px;\n      }\n\n      .cls-17 {\n        fill: #90e2ed;\n        stroke: #90e2ed;\n      }\n\n      .cls-18, .cls-20 {\n        stroke: #b990c8;\n      }\n\n      .cls-18, .cls-29 {\n        fill: #b990c8;\n      }\n\n      .year-arcane {\n        font-size: 12px;\n      }\n\n      .static-years {\n        font-size: 22px;\n      }\n\n      .cls-30, .cls-22 {\n        fill: #bfe581;\n      }\n\n      .cls-19, .cls-21, .cls-11, .cls-27 {\n        stroke: #DACAB7;\n      }\n\n      .cls-21 {\n        stroke-dasharray: 11.27 9.39 11.27 9.39 11.27 9.39;\n      }\n\n      .cls-22 {\n        stroke: #bfe581;\n      }\n\n      .cls-23, .cls-20 {\n        stroke-width: 3px;\n      }\n\n      .cls-23, .cls-24 {\n        stroke: #EE6A71;\n      }\n\n      .cls-31, .cls-24 {\n        fill: #ee6a71;\n      }\n\n      .cls-25 {\n        fill: #7589FC;\n        stroke: #7589FC;\n      }\n\n      .cls-26 {\n        fill: #fff16c;\n        stroke: #ffed47;\n      }\n\n      .cls-27 {\n        stroke-dasharray: 11.27 9.39 11.27 9.39;\n      }\n\n      .cls-28 {\n        fill: #232120;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart_baselines",
    className: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baselines"
  }, /*#__PURE__*/React.createElement("line", {
    id: "sky_line",
    className: "cls-28",
    x1: 434.32,
    y1: 211.67,
    x2: 434.32,
    y2: 588.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "earth_line",
    className: "cls-16",
    x1: 247.53,
    y1: 400.24,
    x2: 624.67,
    y2: 400.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "male_line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 434.45,
    y1: 400.72,
    x2: 316.33,
    y2: 280.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 434.45,
    y1: 400.72,
    x2: 317.86,
    y2: 282.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "328.33 281.28 328.25 283.28 318.4 282.85 318.68 292.7 316.68 292.76 316.34 280.75 328.33 281.58"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 434.95,
    y1: 400.72,
    x2: 558.41,
    y2: 524.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 434.95,
    y1: 400.72,
    x2: 556.88,
    y2: 522.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "546.41 523.74 546.48 521.74 556.33 522.1 555.97 512.25 557.97 512.17 558.41 524.18 546.41 523.74"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "female_line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 434.9,
    y1: 400.52,
    x2: 553.65,
    y2: 280.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 434.9,
    y1: 400.52,
    x2: 551.36,
    y2: 283.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "553.07 298.77 550.07 298.68 550.55 283.9 535.77 284.5 535.65 281.5 553.65 280.77 553.07 298.77"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 433.74,
    y1: 401.02,
    x2: 314.03,
    y2: 524.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 433.74,
    y1: 401.02,
    x2: 316.3,
    y2: 521.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "314.43 506.16 317.43 506.23 317.1 521.02 331.87 520.27 332.02 523.26 314.03 524.17 314.43 506.16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "basic_octagon"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "646.28 190.67 433.88 103.44 222 191.95 134.77 404.35 223.28 616.23 435.68 703.47 647.56 614.96 734.79 402.55 646.28 190.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 153.39,
    cy: 359.19,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 161.2,
    cy: 338.98,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 168.98,
    cy: 320.55,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 202.97,
    cy: 236.79,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 195.55,
    cy: 255.91,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 187.53,
    cy: 275.03,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 178.6,
    cy: 297.79,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 267.47,
    cy: 172.95,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 287.29,
    cy: 164.19,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 305.82,
    cy: 156.65,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 389.09,
    cy: 121.46,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 370.32,
    cy: 129.73,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 351.13,
    cy: 137.58,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 328.72,
    cy: 147.36,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 481.33,
    cy: 123.11,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 501.54,
    cy: 130.92,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 519.98,
    cy: 138.69,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 603.73,
    cy: 172.69,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 584.61,
    cy: 165.27,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 565.49,
    cy: 157.25,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 542.73,
    cy: 148.31,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 665.5,
    cy: 237.42,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 674.27,
    cy: 257.23,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 681.81,
    cy: 275.76,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 717,
    cy: 359.03,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 708.72,
    cy: 340.26,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 700.87,
    cy: 321.07,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 691.1,
    cy: 298.66,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 717.52,
    cy: 445.43,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 709.71,
    cy: 465.64,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 701.94,
    cy: 484.08,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 667.94,
    cy: 567.84,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 675.36,
    cy: 548.72,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 683.38,
    cy: 529.59,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 692.32,
    cy: 506.84,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 601.77,
    cy: 633.67,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 581.95,
    cy: 642.44,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 563.42,
    cy: 649.98,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 480.15,
    cy: 685.17,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 498.92,
    cy: 676.9,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 518.12,
    cy: 669.05,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 540.52,
    cy: 659.27,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 388.91,
    cy: 683.91,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 368.7,
    cy: 676.1,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 350.27,
    cy: 668.32,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 266.51,
    cy: 634.33,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 285.63,
    cy: 641.75,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 304.75,
    cy: 649.77,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 327.51,
    cy: 658.7,
    r: 6.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 203.47,
    cy: 567.21,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 194.71,
    cy: 547.39,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 187.17,
    cy: 528.86,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 151.98,
    cy: 445.59,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 160.25,
    cy: 464.36,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 168.1,
    cy: 483.56,
    r: 4.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 177.88,
    cy: 505.96,
    r: 6.54
  }))), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 617.28,
    y1: 409.05,
    x2: 613.04,
    y2: 413.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 606.41,
    y1: 419.95,
    x2: 580.55,
    y2: 445.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 577.23,
    y1: 449.2,
    x2: 449.23,
    y2: 577.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 445.91,
    y1: 580.86,
    x2: 441.67,
    y2: 585.11
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "birth_square",
    className: "cls-15",
    x: 249.31,
    y: 212.88,
    width: 374.72,
    height: 374.72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "personality_square",
    className: "cls-15",
    x: 248.33,
    y: 216.46,
    width: 374.72,
    height: 374.72,
    transform: "translate(413.16 -189.8) rotate(45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: 1,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "talents_top",
    className: "cls-18",
    cx: 435,
    cy: 125,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "talents_top",
    className: "cls-3",
    x: 435.5,
    y: 128,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: 3,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "talents_center",
    className: "cls-25",
    cx: 434.5,
    cy: 178,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "talents_center",
    className: "cls-1",
    x: 434.5,
    y: 180,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: 6,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "talents_bottom",
    className: "cls-17",
    cx: 434.5,
    cy: 213,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "talents_bottom",
    className: "cls-2",
    x: 434.5,
    y: 214,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: 2,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_top_left_top",
    className: "cls-11",
    cx: 239.5,
    cy: 211,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_top_left_top",
    className: "cls-8",
    x: 238,
    y: 214,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: 5,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_top_left_center",
    className: "cls-11",
    cx: 278,
    cy: 246.5,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_top_left_center",
    className: "cls-7",
    x: 278,
    y: 249,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: 8,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_top_left_bottom",
    className: "cls-11",
    cx: 303.5,
    cy: 271,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_top_left_bottom",
    className: "cls-6",
    x: 304,
    y: 272,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: 23,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_material_female_channel_top",
    className: "cls-11",
    cx: 300.5,
    cy: 536,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_material_female_channel_top",
    className: "cls-6",
    x: 300,
    y: 537,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: 26,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_material_female_channel_center",
    className: "cls-11",
    cx: 276,
    cy: 560,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_material_female_channel_center",
    className: "cls-7",
    x: 276,
    y: 562,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: 29,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_material_female_channel_bottom",
    className: "cls-11",
    cx: 238,
    cy: 597,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_material_female_channel_bottom",
    className: "cls-8",
    x: 238,
    y: 600,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: 25,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_material_male_channel_top",
    className: "cls-11",
    cx: 569.5,
    cy: 536,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_material_male_channel_top",
    className: "cls-6",
    x: 569,
    y: 537,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: 28,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_material_male_channel_center",
    className: "cls-11",
    cx: 593,
    cy: 561,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_material_male_channel_center",
    className: "cls-7",
    x: 593,
    y: 563,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: 31,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_male_channel_material_male_channel_bottom",
    className: "cls-11",
    cx: 630,
    cy: 598,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_male_channel_material_male_channel_bottom",
    className: "cls-8",
    x: 630,
    y: 602,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: 4,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_top_right_top",
    className: "cls-11",
    cx: 631.5,
    cy: 211,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_top_right_top",
    className: "cls-8",
    x: 630,
    y: 214,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: 7,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_top_left_center",
    className: "cls-11",
    cx: 593.5,
    cy: 247,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_top_left_center",
    className: "cls-7",
    x: 593,
    y: 250,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: 10,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "soul_female_channel_top_left_bottom",
    className: "cls-11",
    cx: 567.5,
    cy: 269,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "soul_female_channel_top_left_bottom",
    className: "cls-6",
    x: 567,
    y: 271,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: 14,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "health_left_arcane",
    className: "cls-22",
    cx: 334.41,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "health_left_arcane",
    className: "cls-2",
    x: 334.5,
    y: 401.5,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: 9,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "health_top_arcane",
    className: "cls-22",
    cx: 434.5,
    cy: 298.5,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "health_top_arcane",
    className: "cls-2",
    x: 434.5,
    y: 300,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: 11,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "visit_card_channel_left",
    className: "cls-18",
    cx: 161,
    cy: 399,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "visit_card_channel_left",
    className: "cls-3",
    x: 160,
    y: 403,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: 12,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "visit_card_channel_center",
    className: "cls-25",
    cx: 214,
    cy: 400,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "visit_card_channel_center",
    className: "cls-1",
    x: 214,
    y: 403,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: 13,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "visit_card_channel_right",
    className: "cls-17",
    cx: 249,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "visit_card_channel_right",
    className: "cls-2",
    x: 249,
    y: 401,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: 16,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "comfort_zone_channel_center",
    className: "cls-11",
    cx: 492,
    cy: 399,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "comfort_zone_channel_center",
    className: "cls-7",
    x: 492,
    y: 402,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: 17,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "comfort_zone_channel_right",
    className: "cls-11",
    cx: 528.5,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "comfort_zone_channel_right",
    className: "cls-6",
    x: 528,
    y: 401,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: 15,
    className: "group",
    "data-group": "main_arcane"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "main_arcane",
    className: "cls-26",
    cx: 436,
    cy: 399,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "main_arcane",
    className: "cls-3",
    x: 436,
    y: 399,
    dy: "0.1em",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: 27,
    className: "group",
    "data-group": "karmic_tail"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "karmic_tail_top",
    className: "cls-14",
    cx: 435,
    cy: 590,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "karmic_tail_top",
    className: "cls-2",
    x: 435,
    y: 590,
    dy: "0.1rem",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: 30,
    className: "group",
    "data-group": "karmic_tail"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "karmic_tail_center",
    className: "cls-11",
    cx: 436,
    cy: 626,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "karmic_tail_center",
    className: "cls-7",
    x: 436,
    y: 628,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: 32,
    className: "group",
    "data-group": "karmic_tail"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "karmic_tail_bottom",
    className: "cls-24",
    cx: 436,
    cy: 679,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "karmic_tail_bottom",
    className: "cls-3",
    x: 435,
    y: 683,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: 19,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "main_material_channel_center",
    className: "cls-11",
    cx: 659.5,
    cy: 400,
    r: 20
  }), /*#__PURE__*/React.createElement("text", {
    id: "main_material_channel_center",
    className: "cls-7",
    x: 659.5,
    y: 400,
    dy: "0.1rem",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: 18,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "main_material_channel_left",
    className: "cls-14",
    cx: 625,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "main_material_channel_left",
    className: "cls-2",
    x: 625,
    y: 401,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: 20,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "main_material_channel_right",
    className: "cls-24",
    cx: 712,
    cy: 400,
    r: 30
  }), /*#__PURE__*/React.createElement("text", {
    id: "main_material_channel_right",
    className: "cls-3",
    x: 711,
    y: 402,
    dy: "0.1rem",
    dx: "0.1rem",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: 24,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "relationship_center",
    className: "cls-11",
    cx: 484.5,
    cy: 542,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "relationship_center",
    className: "cls-6",
    x: 484,
    y: 543.5,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: 22,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "intersection_of_channels_of_relations_and_finance",
    className: "cls-11",
    cx: 529,
    cy: 497,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "intersection_of_channels_of_relations_and_finance",
    className: "cls-6",
    x: 529,
    y: 498,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: 21,
    className: "group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "finance_center",
    className: "cls-11",
    cx: 577,
    cy: 449.3,
    r: 12
  }), /*#__PURE__*/React.createElement("text", {
    id: "finance_center",
    className: "cls-6",
    x: 576.5,
    y: 450,
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "0"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart_icon",
    className: "cls-31",
    d: "M476.21,521.3l-7.17-6.83c-7.54-7.09,2.04-11.69,6.69-6.39,3.97-5.66,14.14-1.53,7.23,6.12l-6.75,7.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "money_icon",
    className: "cls-30",
    d: "M566.11,427.62c-.6-.66-1.6-1.29-3.02-1.9l-1.37-.58c-.93-.38-1.56-.72-1.9-1.02-.33-.29-.5-.67-.5-1.14,0-.59.22-1.04.67-1.37.44-.32,1.04-.49,1.79-.49,1.33,0,2.55.55,3.64,1.64l1.43-1.46c-1.07-1.29-2.39-2.04-3.95-2.26v-2.32h-2.33v2.38c-.85.17-1.6.48-2.23.98-.94.75-1.41,1.75-1.41,3,0,.95.29,1.74.88,2.37.59.63,1.52,1.2,2.79,1.73l1.43.61c.97.39,1.64.73,2.02,1.05.37.31.56.75.56,1.32,0,.65-.26,1.16-.79,1.53s-1.2.56-2.03.56-1.5-.18-2.14-.55-1.34-.94-2.11-1.73l-1.49,1.55c1.25,1.62,2.82,2.55,4.7,2.81v2.5h2.33v-2.54c.91-.16,1.72-.49,2.4-1,1.01-.77,1.52-1.84,1.52-3.22,0-.99-.3-1.82-.9-2.47Z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "static_age_group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "age_group_0-10"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(159.4 363.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1-2")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(167.91 343.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2-3")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(175.6 324.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3-4")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(187.81 302.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(194.6 279.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6-7")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(201.92 261.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7-8")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(209.27 241.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8-9"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_10-20"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(266.14 184.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11-12")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(285.11 176.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12-13")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(303.1 168.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13-14")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(349.02 149.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16-17")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(367.32 142.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17-18")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(385.25 135.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18-19")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(330.36 159.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_20-30"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(468.74 135.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21-22")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(488.1 143.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22-23")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(505.34 150.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23-24")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(551.5 169.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "26-27")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(571.59 178.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27-28")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(592.52 186.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28-29")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(533.11 160.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_30-40"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(643.17 245.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "31-32")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(650.34 263.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "32-33")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(657.98 281.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "33-34")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(673.69 304.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "35")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(676.13 327.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "36-37")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(685.13 346.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "37-38")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(692.71 365.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "38-39"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_40-50"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(691.72 448.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "41-42")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(684.3 468.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "42-43")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(675.53 488.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "43-44")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(659.27 531.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "46-47")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(650.54 550.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "47-48")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(643.3 567.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "48-49")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(676.85 505.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "45"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_50-60"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(584.15 627.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "51-52")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(566.17 635.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "52-53")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(546.22 643.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "53-54")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(503.79 662.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "56-57")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(485.95 669.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "57-58")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(469.32 675.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "58-59")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(533.98 649.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "55"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_60-70"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(385.22 675.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "61-62")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(366.59 668.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "62-63")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(348.95 660.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "63-64")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(304.51 642.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "66-67")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(284.87 634.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "67-68")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(265.78 626.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "68-69")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(327.51 650.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "65"))), /*#__PURE__*/React.createElement("g", {
    id: "age_group_70-0"
  }, /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(211.24 567.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "71-72")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(203.78 550.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "72-73")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(195.49 530.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "73-74")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(175.98 485.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "76-77")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(169.32 467.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "77-78")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(160.25 448.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "78-79")), /*#__PURE__*/React.createElement("text", {
    className: "age_group-item",
    transform: "translate(187.47 506.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "75"))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "dynamic_year_arcane"
  }, /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_0-10"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "1-2",
    className: "year-arcane",
    transform: "translate(130 360)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "2-3",
    className: "year-arcane",
    transform: "translate(138 339)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "3-4",
    className: "year-arcane",
    transform: "translate(146 319)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 5,
    className: "year-arcane",
    transform: "translate(154 298)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "6-7",
    className: "year-arcane",
    transform: "translate(163 275)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "7-8",
    className: "year-arcane",
    transform: "translate(171 256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "8-9",
    className: "year-arcane",
    transform: "translate(180 237)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_10-20"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "11-12",
    className: "year-arcane",
    transform: "translate(260 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "12-13",
    className: "year-arcane",
    transform: "translate(280 150)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "13-14",
    className: "year-arcane",
    transform: "translate(300 142)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 15,
    className: "year-arcane",
    transform: "translate(320 134)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "16-17",
    className: "year-arcane",
    transform: "translate(340 126)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "17-18",
    className: "year-arcane",
    transform: "translate(360 118)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "18-19",
    className: "year-arcane",
    transform: "translate(380 110)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_20-30"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "21-22",
    className: "year-arcane",
    transform: "translate(480 110)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "22-23",
    className: "year-arcane",
    transform: "translate(500 118)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "23-24",
    className: "year-arcane",
    transform: "translate(520 126)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 25,
    className: "year-arcane",
    transform: "translate(544 136)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "26-27",
    className: "year-arcane",
    transform: "translate(565 146)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "27-28",
    className: "year-arcane",
    transform: "translate(585 154)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "28-29",
    className: "year-arcane",
    transform: "translate(605 162)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_30-40"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "31-32",
    className: "year-arcane",
    transform: "translate(680 240)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "32-33",
    className: "year-arcane",
    transform: "translate(690 260)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "33-34",
    className: "year-arcane",
    transform: "translate(698 279)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 35,
    className: "year-arcane",
    transform: "translate(708 300)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "36-37",
    className: "year-arcane",
    transform: "translate(718 324)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "37-38",
    className: "year-arcane",
    transform: "translate(726 343)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "38-39",
    className: "year-arcane",
    transform: "translate(734 360)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_40-50"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "41-42",
    className: "year-arcane",
    transform: "translate(732 450)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "42-43",
    className: "year-arcane",
    transform: "translate(724 470)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "43-44",
    className: "year-arcane",
    transform: "translate(716 488)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 45,
    className: "year-arcane",
    transform: "translate(708 512)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "46-47",
    className: "year-arcane",
    transform: "translate(698 534)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "47-48",
    className: "year-arcane",
    transform: "translate(690 554)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "48-49",
    className: "year-arcane",
    transform: "translate(682 572)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_50-60"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "51-52",
    className: "year-arcane",
    transform: "translate(602 656)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "52-53",
    className: "year-arcane",
    transform: "translate(582 664)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "53-54",
    className: "year-arcane",
    transform: "translate(563 672)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 55,
    className: "year-arcane",
    transform: "translate(542 682)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "56-57",
    className: "year-arcane",
    transform: "translate(520 690)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "57-58",
    className: "year-arcane",
    transform: "translate(502 698)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "58-59",
    className: "year-arcane",
    transform: "translate(481 706)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_60-70"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "61-62",
    className: "year-arcane",
    transform: "translate(380 705)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "62-63",
    className: "year-arcane",
    transform: "translate(360 697)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "63-64",
    className: "year-arcane",
    transform: "translate(342 690)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 65,
    className: "year-arcane",
    transform: "translate(318 680)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "66-67",
    className: "year-arcane",
    transform: "translate(296 670)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "67-68",
    className: "year-arcane",
    transform: "translate(276 662)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "68-69",
    className: "year-arcane",
    transform: "translate(256 654)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("g", {
    id: "year_arcane_70-0"
  }, /*#__PURE__*/React.createElement("text", {
    "data-key": "71-72",
    className: "year-arcane",
    transform: "translate(180 572)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "72-73",
    className: "year-arcane",
    transform: "translate(170 552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "73-74",
    className: "year-arcane",
    transform: "translate(162 532)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": 75,
    className: "year-arcane",
    transform: "translate(154 512)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "76-77",
    className: "year-arcane",
    transform: "translate(144 488)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "77-78",
    className: "year-arcane",
    transform: "translate(136 470)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    "data-key": "78-79",
    className: "year-arcane",
    transform: "translate(128 450)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "static_years"
  }, /*#__PURE__*/React.createElement("text", {
    id: "0_years",
    className: "static-years",
    transform: "translate(108.68 409.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "10_years",
    className: "static-years",
    transform: "translate(188.54 184.28) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("text", {
    id: "20_years",
    className: "static-years",
    transform: "translate(424.32 86.23) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "30_years",
    className: "static-years",
    transform: "translate(663.56 184.5) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    id: "40_years",
    className: "static-years",
    transform: "translate(753.2 409.05) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40")), /*#__PURE__*/React.createElement("text", {
    id: "50_years",
    className: "static-years",
    transform: "translate(665.5 633.9) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("text", {
    id: "60_years",
    className: "static-years",
    transform: "translate(422.68 735.18) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "60")), /*#__PURE__*/React.createElement("text", {
    id: "70_years",
    className: "static-years",
    transform: "translate(188.4 634.33) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "70")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoulMatrix);
export default __webpack_public_path__ + "static/media/soul-matrix.52e6637a83dd391ba396dcf61f1fc4a4.svg";
export { ForwardRef as ReactComponent };